import ModalCenter from "../../../components/modal/modalCenter";
import { useContext, useEffect, useState } from "react";
import styles from './modalReclamo.module.css'
import Btn from "../../../components/btn/btn";
import InputSelect from "../../../components/inputSelect/inputSelect";
import ApiFetch from "../../../utils/fetch";
import Input from "../../../components/input/input";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import SwalAlert from "../../../utils/swalAlert";
import Loading from "../../../components/loading/loading";
import { AppContext } from "../../../context/context";


const fetch = new ApiFetch();
const alert = new SwalAlert()

const ModalReclamo = ({ idPrestacion, service, onReclamoCreado }) => {
    const {user,sessionExpired} = useContext(AppContext)
    const [show, setShow] = useState(false);
    const [fallas, setFallas] = useState('')
    const [idTipoFallaDec, setIdTipoFallaDec] = useState('')
    const [observacion, setObservacion] = useState('')
    const [nroTelefono, setNroTelefono] = useState('')
    const [estadoServicio, setEstadoServicio] = useState(false);
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [loading, setLoading] = useState('');

    const getFallas = async () => {
        try {
            setLoading(<Loading/>)
            const data = await fetch.GET(`/reclamos/fallas/${idPrestacion}`);
            setLoading('')
            const message = data?.message
            if (data?.status === 401) {
                sessionExpired(message)
                return;
            }
              setShow(true)
            setFallas(data?.body)
        } catch (error) {
            setLoading('')
            alert.error('Hubo un error, por favor intente nuevamente más tarde.')
        }
    }

    const realizarReclamo = async () => {
        if (!idTipoFallaDec || !observacion || !nroTelefono) {
            alert.warning ('Debe cargar todos los datos solicitados.')
            return;
        }
        try {
            setLoading(<Loading/>)
            const body = JSON.stringify({
                idPrestacion,
                idTipoFallaDec,
                observacion,
                nroTelefono,
                reclamante:user,
                estadoServicio:estadoServicio ? 1 : 0,
            })
            const data = await fetch.POST(body, '/reclamos/nuevo')
            setLoading('')
            const status = data?.status
            const message = data?.message
            switch (status) {
                case 201:
                    alert.success(message)
                    setShow(false)
                    if(onReclamoCreado) onReclamoCreado();
                    setIdTipoFallaDec('')
                    setObservacion('')
                    setNroTelefono('')
                    setEstadoServicio(false)
                    break;
                case 401:
                    sessionExpired(message)
                    break;
                case 500:
                    alert.error(message)
                    break;
                default:
                     alert.warning(message)
                    break;
            }
        } catch (error) {
            setLoading('')
            alert.error('Hubo un error, por favor intente nuevamente más tarde.')
        }
    }

    useEffect(() => {
        if (!idTipoFallaDec || !observacion || !nroTelefono) {
            setDisabledBtn(true)
        } else {
            setDisabledBtn(false)
        }
    }, [idTipoFallaDec, observacion, nroTelefono, estadoServicio])
    
    return(
        <>
            <Btn action={()=>getFallas()} text='Reclamo' variant='outlined' color='warning'/>
            <ModalCenter show={show} setShow={setShow} title={`Reclamo de ${service}`}>
                <div className={styles.container}>
                    <div className={styles.form}>
                    <InputSelect size='small' label='Seleccione la falla' items={fallas} value={idTipoFallaDec} setValue={setIdTipoFallaDec}/>
                    <Input type='text' maxLength={250} multiline={true} rows={3} value={observacion} setValue={setObservacion} size='small' variant='outlined' label={`Observación (${250 - observacion.length})`}  />
                    <Input type='number' maxLength={11} value={nroTelefono} setValue={setNroTelefono} size='small' variant='outlined' label='Nro de Contacto' helperText='Ingrese Código de área seguido de su número de teléfono sin el 15.' />
                    <div>
                    <FormControlLabel control={<Checkbox checked={estadoServicio} onChange={()=>setEstadoServicio(!estadoServicio)} />} label="¿ Tiene servicio ?" labelPlacement="start" />
                    </div>
                    </div>
                    <Btn disabled={disabledBtn} action={()=>realizarReclamo()} text='Enviar reclamo' />
                </div>
            </ModalCenter>
            {loading}
        </>
    )
}

export default ModalReclamo;